/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const sectionDouble = {
    init: function () {
      // convert texts to dashed texts
      document.querySelectorAll('[data-action-dashed]').forEach((item) => {
        const toDash = item.getAttribute('data-action-dashed')

        // Skip if attribute is missing, empty, or just whitespace
        if (!toDash || !toDash.trim()) return

        item.childNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "P") {
            const regex = new RegExp(`\\b${toDash}\\b`, "g")
            node.innerHTML = node.innerHTML.replace(
              regex,
              `<span class="text-style-dash-wrapper">
                <span class="text-style-dash">${toDash}</span>
              </span>`
            )
          }
        })
      })
    }
  }

  const sectionContentVideos = {
    init: function () {
      document.addEventListener('click', function (e) {
        const target = e.target.closest('.video-background__play-icon .video__poster')
        if (target) {
          const parent = target.closest('.video-background__play-icon')
          if (parent) {
            const videoBackground = parent.querySelector("video-background");
            if (videoBackground) {
              videoBackground.click()
              target.classList.add('video__poster-hidden-before')
            }
          }
        }
      })
    }
  }

  const sectionColumnsImages = {
    init: function () {
      document.querySelectorAll("[data-hover-images]").forEach((column) => {
        const img = column.querySelector("img")
        const hoverImages = column.dataset.hoverImages
          .replace(/[\[\]]/g, "")
          .split(",")
          .map((src) => src.trim())
          .filter((src) => src)

        if (!hoverImages.length) return

        let currentIndex = 0
        let isHovering = false
        let animationFrame

        img.dataset.originalSrc = img.src

        const overlayImg = document.createElement("img")
        overlayImg.src = img.src
        overlayImg.classList.add("hover-fade-image")
        img.parentElement.appendChild(overlayImg)

        // Preload images to avoid blank image on hover
        const preloadedImages = hoverImages.map((src) => {
          const image = new Image()
          image.src = src
          return image
        })

        function fadeLoop() {
          if (!isHovering) return

          const nextIndex = (currentIndex + 1) % hoverImages.length

          overlayImg.src = preloadedImages[nextIndex].src
          overlayImg.classList.add("hover-fade-in")

          setTimeout(() => {
            img.src = hoverImages[nextIndex]
            overlayImg.classList.remove("hover-fade-in")

            currentIndex = nextIndex
            animationFrame = requestAnimationFrame(fadeLoop)
          }, 1500)
        }

        column.addEventListener("mouseenter", () => {
          isHovering = true
          fadeLoop()
        })

        column.addEventListener("mouseleave", () => {
          isHovering = false
          cancelAnimationFrame(animationFrame)

          overlayImg.src = img.dataset.originalSrc
          overlayImg.classList.add("hover-fade-in")

          setTimeout(() => {
            img.src = img.dataset.originalSrc
            overlayImg.classList.remove("hover-fade-in")
          }, 500)
        })
      })

    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    sectionDouble.init()
    sectionContentVideos.init()
    sectionColumnsImages.init()
  })

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
